// Zeit-/Überzug-Berechnung — geteilt zwischen Kapazitätsplanung und der
// Auftrags-Zeiterfassung (OrderTimePanel). Reine Funktionen, keine Vue-Abhängigkeit.

// Stunden (Dezimal) → "H:MM".
export function fmtHM(hours) {
  const h = Math.max(0, hours || 0)
  const whole = Math.floor(h)
  const mins = Math.round((h - whole) * 60)
  return `${whole}:${String(mins).padStart(2, '0')}`
}

// Sekunden → "H:MM".
export function fmtSeconds(sec) {
  return fmtHM((sec || 0) / 3600)
}

// Stunden zwischen zwei Zeit-Strings; offenes Ende → bis `nowMs`.
export function hoursBetween(startStr, endStr, nowMs = Date.now()) {
  if (!startStr) return 0
  const start = new Date(startStr).getTime()
  const end = endStr ? new Date(endStr).getTime() : nowMs
  return Math.max(0, (end - start) / 3_600_000)
}

// Kalkulierte Dauer eines Auftrags aus geplant_start/geplant_ende (Stunden).
export function calcHours(order) {
  return hoursBetween(order && order.geplant_start, order && order.geplant_ende, 0)
}

// Welche Maschinenkategorie eine Etappe belegt. Nur Druck und WV laufen auf
// einer Maschine mit eigenem Planfenster. Spiegelt Order::STAGE_MACHINE_CATEGORY.
export const STAGE_MACHINE_CATEGORY = {
  printing_complete: 'druck',
  processing_complete: 'wv'
}

// Kalkulierte Dauer EINER Etappe (Stunden), aus dem Planfenster der Maschinen-
// Zuordnung dieser Etappe. `null` heißt: für diese Etappe gibt es keine
// kalkulierte Zeit — dann darf auch kein Überzug angezeigt werden.
//
// Vorher maß jede Etappe gegen das Gesamtfenster des Auftrags, die Vorstufe
// also am Budget des Drucks. Ein falscher Vergleich ist schlechter als keiner.
export function calcHoursForStage(order, stage, categoryOf) {
  const category = STAGE_MACHINE_CATEGORY[stage]
  if (!order || !category || typeof categoryOf !== 'function') return null

  const rows = Array.isArray(order.machine_assignments) ? order.machine_assignments : []
  const hit = rows.find(a => categoryOf(a.maschine_name) === category)
  if (!hit || !hit.geplant_start || !hit.geplant_ende) return null

  return hoursBetween(hit.geplant_start, hit.geplant_ende, 0)
}

// Fortschritt in % (auf 100 gedeckelt). Ohne Kalk-Zeit: 100 wenn schon Zeit
// verbraucht, sonst 0.
export function progressPct(consumedHours, calcHrs) {
  if (!calcHrs || calcHrs <= 0) return consumedHours > 0 ? 100 : 0
  return Math.min(100, Math.round((consumedHours / calcHrs) * 100))
}

// Überzug ab 100 % (Chef 2026-07: kein 20-%-Puffer).
export function isOvertime(consumedHours, calcHrs) {
  return calcHrs > 0 && consumedHours > calcHrs
}

// M-4 — Warnschwelle: verbrauchte Zeit > 120 % der kalkulierten. Eigene Stufe
// über `isOvertime` (>100 %); triggert die rot-fette Hervorhebung in der Kap.Pl.
export function isOver120(consumedHours, calcHrs) {
  return calcHrs > 0 && consumedHours > calcHrs * 1.2
}

export function overtimeHours(consumedHours, calcHrs) {
  return Math.max(0, consumedHours - calcHrs)
}
